(() => {
  const setupRadarHeroes = (root = document) => {
    root.querySelectorAll('[data-gp-radar]').forEach((section) => {
      if (section.dataset.gpRadarReady === 'true') return;

      const carousel = section.querySelector('[data-gp-radar-carousel]');
      const cards = [...section.querySelectorAll('[data-gp-radar-card]')];
      const previousButton = section.querySelector('[data-gp-radar-prev]');
      const nextButton = section.querySelector('[data-gp-radar-next]');
      const currentCounter = section.querySelector('[data-gp-radar-current]');
      const dotsContainer = section.querySelector('[data-gp-radar-dots]');
      if (!carousel || cards.length === 0) return;

      const fields = {
        subject: section.querySelector('[data-gp-radar-subject]'),
        name: section.querySelector('[data-gp-radar-name]'),
        charge: section.querySelector('[data-gp-radar-charge]'),
        status: section.querySelector('[data-gp-radar-status]'),
        reward: section.querySelector('[data-gp-radar-reward]'),
        mobileSubject: section.querySelector('[data-gp-radar-mobile-subject]'),
        mobileName: section.querySelector('[data-gp-radar-mobile-name]'),
        mobileCharge: section.querySelector('[data-gp-radar-mobile-charge]'),
        mobileStatus: section.querySelector('[data-gp-radar-mobile-status]'),
      };
      const pad = (value) => String(value).padStart(2, '0');
      let activeIndex = 0;
      let pointerStart = null;
      let suppressClick = false;

      const dots = cards.map((card, index) => {
        const dot = document.createElement('i');
        dot.dataset.index = String(index);
        dotsContainer?.appendChild(dot);
        return dot;
      });

      const updateDatabase = (card, index) => {
        const subject = pad(index + 1);
        const title = card.dataset.title || '';
        const charge = card.dataset.charge || '';
        const status = card.dataset.status || '';
        const reward = card.dataset.reward || '';

        if (fields.subject) fields.subject.textContent = subject;
        if (fields.name) fields.name.textContent = title;
        if (fields.charge) fields.charge.textContent = charge;
        if (fields.status) fields.status.textContent = status;
        if (fields.reward) fields.reward.textContent = reward;
        if (fields.mobileSubject) fields.mobileSubject.textContent = subject;
        if (fields.mobileName) fields.mobileName.textContent = title;
        if (fields.mobileCharge) fields.mobileCharge.textContent = charge;
        if (fields.mobileStatus) fields.mobileStatus.textContent = status;
        if (currentCounter) currentCounter.textContent = subject;
      };

      const showProduct = (nextIndex) => {
        const count = cards.length;
        activeIndex = (nextIndex + count) % count;
        const previousIndex = (activeIndex - 1 + count) % count;
        const followingIndex = (activeIndex + 1) % count;

        cards.forEach((card, index) => {
          const link = card.querySelector('a');
          const isActive = index === activeIndex;
          const isPrevious = count > 2 && index === previousIndex;
          const isNext = count > 1 && index === followingIndex;

          card.classList.toggle('is-active', isActive);
          card.classList.toggle('is-prev', isPrevious);
          card.classList.toggle('is-next', isNext);
          card.classList.toggle('is-hidden', !isActive && !isPrevious && !isNext);
          card.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          if (isActive) card.setAttribute('aria-current', 'true');
          else card.removeAttribute('aria-current');
          if (link) link.tabIndex = isActive ? 0 : -1;
        });

        dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
        updateDatabase(cards[activeIndex], activeIndex);
      };

      const move = (direction) => showProduct(activeIndex + direction);
      previousButton?.addEventListener('click', () => move(-1));
      nextButton?.addEventListener('click', () => move(1));

      carousel.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });

      carousel.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
        suppressClick = false;
      }, { passive: true });

      carousel.addEventListener('pointermove', (event) => {
        if (!pointerStart || event.pointerId !== pointerStart.id) return;
        if (Math.abs(event.clientX - pointerStart.x) > 12) suppressClick = true;
      }, { passive: true });

      carousel.addEventListener('pointerup', (event) => {
        if (!pointerStart || event.pointerId !== pointerStart.id) return;
        const deltaX = event.clientX - pointerStart.x;
        const deltaY = event.clientY - pointerStart.y;
        pointerStart = null;
        if (Math.abs(deltaX) >= 46 && Math.abs(deltaX) > Math.abs(deltaY)) {
          move(deltaX < 0 ? 1 : -1);
        }
      }, { passive: true });

      carousel.addEventListener('pointercancel', () => { pointerStart = null; }, { passive: true });
      carousel.addEventListener('click', (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        suppressClick = false;
      });

      cards.forEach((card) => {
        card.querySelector('img')?.setAttribute('draggable', 'false');
      });

      showProduct(0);
      section.dataset.gpRadarReady = 'true';
    });
  };

  setupRadarHeroes();
  document.addEventListener('shopify:section:load', (event) => setupRadarHeroes(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest?.('[data-gp-radar-card]');
    const section = card?.closest?.('[data-gp-radar]');
    if (!card || !section) return;
    const cards = [...section.querySelectorAll('[data-gp-radar-card]')];
    const targetIndex = cards.indexOf(card);
    if (targetIndex < 0) return;
    section.querySelector('[data-gp-radar-carousel]')?.focus({ preventScroll: true });
    const currentIndex = cards.findIndex((item) => item.classList.contains('is-active'));
    const steps = (targetIndex - currentIndex + cards.length) % cards.length;
    const nextButton = section.querySelector('[data-gp-radar-next]');
    for (let index = 0; index < steps; index += 1) nextButton?.click();
  });
})();
